module.exports = __webpack_public_path__ + "static/media/Camera11.eaaf53cb.jpg";